import { render } from "./ShowInvoiceInventoryDetail.vue?vue&type=template&id=f9c1a3f2"
import script from "./ShowInvoiceInventoryDetail.vue?vue&type=script&lang=js"
export * from "./ShowInvoiceInventoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__